const logos = {
  chubb:                require("./chubb.png"),
  forcefieldLogoOrange: require("./forcefield-logo-orange.svg").default,
  // The square Forcefield mark, for places too small for the wordmark, such
  // as the bootsplash.
  forcefieldLogoSmall:  require("./forcefield-logo-small.svg").default,
  logo:                 require("./logo.svg").default,
  logoBig:              require("./logo-big.svg").default,
  logoBigPng:           require("./logo-big.png"),
  logoBigWhite:         require("./logo-big-white.svg").default,
  logoPng:              require("./logo.png"),
  noImage:              require("./no-image.png"),
  poweredBy:            require("./poweredby.png")
}

export default logos
